export default "__VITE_ASSET__BDpvMIGB__"